import ExportAction from "./export/ExportAction.js";
const install = molten => {
  molten.addPlugin('Action', {
    id: 'molten.dataViewers.export.ExportAction',
    matches: {
      use: 'actionBar',
      client: ['TableDataViewer', 'ListDataViewer']
    },
    ...ExportAction(molten)
  });
  molten.addPlugin('Action', {
    id: 'molten.dataViewers.export.HistoryExportAction',
    matches: {
      use: 'actionBar',
      client: ['HistoryView']
    },
    ...ExportAction(molten, 'history')
  });
};
export default {
  install
};